import { createRenameDssEntityMutation, type EntityData } from '@entity';
import { createSignal, onMount } from 'solid-js';
import { EntityModalActionFooter, EntityModalTitle } from './EntityModal';

export const RenameView = (props: {
  entity?: EntityData;
  viewId?: string;
  onFinish: () => void;
  onCancel: () => void;
}) => {
  const renameMutation = createRenameDssEntityMutation();
  let inputRef: HTMLInputElement | undefined;

  const [editValue, setEditValue] = createSignal(props.entity?.name || '');

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      finishEditing();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      props.onCancel();
    }
  };

  const finishEditing = async () => {
    const newValue = editValue().trim();

    // Handle entity renaming
    if (newValue && props.entity) {
      await renameMutation.mutateAsync({
        entity: props.entity,
        newName: newValue,
      });
    }

    props.onFinish();
  };

  return (
    <div class="w-full">
      <EntityModalTitle title="Rename" />
      <div class="w-full">
        <input
          ref={(el) => {
            inputRef = el;
            onMount(() => {
              // it needs to focus on next task, no idea why
              setTimeout(() => {
                inputRef?.focus();
                inputRef?.select();
              });
            });
          }}
          value={editValue()}
          onInput={(e) => setEditValue(e.currentTarget.value)}
          onKeyDown={handleKeyDown}
          class="w-full p-2 text-sm border border-edge bg-surface text-ink placeholder:text-ink-placeholder focus:outline-none focus:bg-active selection:bg-ink selection:text-surface"
          placeholder="Enter title..."
        />
      </div>

      <EntityModalActionFooter
        onCancel={props.onCancel}
        onConfirm={finishEditing}
        confirmText="Rename"
      />
    </div>
  );
};
